import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store';
import vuetify from './plugins/vuetify';
import i18n from "@/_lang/lang"

import 'primevue/resources/primevue.min.css'
import 'primevue/resources/themes/bootstrap4-light-blue/theme.css'
import 'primeicons/primeicons.css'

import VEnumSpan from '@/components/ui/VEnumSpan.vue'
import VPageToolbar from '@/components/ui/VPageToolbar.vue'
import VDataTable from '@/components/ui/VDataTable.vue'
import VCreateButton from '@/components/ui/VCreateButton.vue'
import VMap from '@/components/ui/VMap.vue'

// If you don't need the styles, do not connect
import Iconifier from "vue2-iconifier"

import VueSweetalert2 from 'vue-sweetalert2';
// If you don't need the styles, do not connect

import 'sweetalert2/dist/sweetalert2.min.css';
import VueLayers from 'vuelayers'
import 'vuelayers/lib/style.css' // needs css-loader
import VueMask from 'v-mask'
import { Enums } from "@/_models/enums";

Vue.use(VueMask)
Vue.use(VueLayers)
Vue.use(VueSweetalert2);

Vue.use(Iconifier)

Vue.component('v-enum-span', VEnumSpan)
Vue.component('v-page-toolbar', VPageToolbar)
Vue.component('v-create-button', VCreateButton)
Vue.component('vdata-table', VDataTable)
Vue.component('v-map', VMap)

Vue.config.productionTip = false
Vue.prototype.$enums = Enums;

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
